import { Pipe, PipeTransform } from "@angular/core";

export enum FloorplanMenuType {
  MAIN_SETTINGS,
  PRODUCT_SEARCH,
  GROUP,
  ZONE,
  GAS_WARNING_CENTER,
  TRANSMITTER,
  FLAME_DETECTOR,
  SIGNAL_ELEMENT,
  PLASTIC_SIGN,
  ALARM_DEVICE,
  IMAGE,
  WIRING,
  AIR_PATH,
  ANNOTATION,
  DIMENSIONS,
  MONITORING_ZONE,
  MONITORING_PATIENT_MONITOR,
  MONITORING_CENTRAL_STATION,
  MONITORING_TELEMETRY,
  MONITORING_KVM,
  MONITORING_DISPLAY,
  MONITORING_UTILITY,
  MONITORING_PRODUCT_SEARCH,
}

@Pipe({
  standalone: true,
  name: "localizeFloorplanMenuType",
})
export class LocalizeFloorplanMenuTypePipe implements PipeTransform {
  private readonly menuTypeToLocalizedStringMap = {
    [FloorplanMenuType.MAIN_SETTINGS]: $localize`:@@floorplan.menu.mainSettings.header:Allgemeine Einstellungen`,
    [FloorplanMenuType.PRODUCT_SEARCH]: $localize`:@@floorplan.menu.productSearch.header:Produktsuche`,
    [FloorplanMenuType.GROUP]: $localize`:@@global.groups:Gruppen`,
    [FloorplanMenuType.ZONE]: $localize`:@@global.zones:Zonen`,
    [FloorplanMenuType.MONITORING_ZONE]: $localize`:@@global.zones:Zonen`,
    [FloorplanMenuType.MONITORING_PATIENT_MONITOR]: $localize`:@@global.patientMonitors:Patient Monitors`,
    [FloorplanMenuType.MONITORING_CENTRAL_STATION]: $localize`:@@global.centralStations:Central Stations`,
    [FloorplanMenuType.MONITORING_TELEMETRY]: $localize`:@@global.telemetries:Telemetry`,
    [FloorplanMenuType.MONITORING_KVM]: $localize`:@@global.kvms:KVMs`,
    [FloorplanMenuType.MONITORING_DISPLAY]: $localize`:@@global.displays:Displays`,
    [FloorplanMenuType.MONITORING_UTILITY]: $localize`:@@global.utilities:Utility`,
    [FloorplanMenuType.GAS_WARNING_CENTER]: $localize`:@@global.gasWarningCenters:Gaswarnzentralen`,
    [FloorplanMenuType.TRANSMITTER]: $localize`:@@global.transmitters:Transmitter`,
    [FloorplanMenuType.FLAME_DETECTOR]: $localize`:@@global.flameDetectors:Brandmelder`,
    [FloorplanMenuType.SIGNAL_ELEMENT]: $localize`:@@global.signalElements:Leuchttransparente`,
    [FloorplanMenuType.PLASTIC_SIGN]: $localize`:@@global.plasticSigns:Kunststoffschilder`,
    [FloorplanMenuType.ALARM_DEVICE]: $localize`:@@global.alarmDevices:Alarmmittel`,
    [FloorplanMenuType.IMAGE]: $localize`:@@global.images:Fotos`,
    [FloorplanMenuType.WIRING]: $localize`:@@global.wiring:Montage & Verkabelung`,
    [FloorplanMenuType.AIR_PATH]: $localize`:@@global.airPaths:Zu-/Abluftwege`,
    [FloorplanMenuType.ANNOTATION]: $localize`:@@global.annotations:Anmerkungen`,
    [FloorplanMenuType.DIMENSIONS]: $localize`:@@global.dimensions:Maße`,
    [FloorplanMenuType.MONITORING_PRODUCT_SEARCH]: $localize`:@@floorplan.menu.productSearch.header:Produktsuche`,
  };

  transform(value: FloorplanMenuType): string {
    return this.menuTypeToLocalizedStringMap[value];
  }
}
